import { useRef } from 'react'
import { useTable } from 'react-table'
import * as XLSX from 'xlsx'
import './reacttable.css'

export const ReactTable = ({ data, columns, fileName, sheetName}: any) => {
  const tableRef = useRef(null);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    columns: columns,
    data: data.filter((r: any) => !r.isFooterInfo)
  })

  const handleExport = () => {
    const exportData = data.map((row: any) => {
      const rowData: any = {};
      columns.forEach((col: any) => {
        rowData[col.accessor] = row[col.accessor];
      });
      return rowData;
    });
    const ws = XLSX.utils.json_to_sheet(exportData, { header: columns.map((col: any) => col.accessor) })

    const headerCount: Record<string, number> = {}
    const accessorToUniqueHeader: Record<string, string> = {}

    columns.forEach((col: any) => {
      const header = col.Header;
      const accessor = col.accessor;

      if (!headerCount[header]) {
        headerCount[header] = 1;
        accessorToUniqueHeader[accessor] = header;
      } else {
        headerCount[header]++;
        accessorToUniqueHeader[accessor] = `${header} (${headerCount[header]})`;
      }
    });

    const headerRow = columns.map((col: any) => accessorToUniqueHeader[col.accessor]);
    XLSX.utils.decode_range(ws['!ref'] || '');
    headerRow.forEach((label : string, colIndex: number) => {
      const address = XLSX.utils.encode_cell({ r: 0, c: colIndex });
      if (ws[address]) ws[address].v = label;
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName || 'Sheet1');
    XLSX.writeFile(wb, `${fileName || 'Export'}_${sheetName || 'Sheet1'}.xlsx`);
  };


  return (
    <>
       <div className='row justify-content-end'>
        {data && data.length > 0 && data.some((r: any) => !r.isFooterInfo) ? <>
            <button className='btn btn-secondary btn-sm col-md-2 exportbtn mb-2' onClick={handleExport}>
              Export to Excel
            </button>
          <div className='table-responsive'>
            <table {...getTableProps()} ref={tableRef} className='table'>
              <thead>
                {headerGroups.map(headerGroup => (
                  <tr className='table-info' {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map(row => {
                  prepareRow(row)
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map(cell => {
                        return <td {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </>
          : <span className='nodataspan'>No data to display</span>}
      </div>
    </>
  )
}